import { Mesa, Objeto, Salon } from "../../types";
import { createMesa } from "../../../../../crud/management_api/mesas";
import { createObjeto } from "../../../../../crud/management_api/objectos";
import { toast } from 'react-toastify';

export function convertMesaFromAPI(mesa: any): Mesa {
    return {
        id: mesa.mesa_id,
        num: mesa.mesa_number.toString(),
        x_pos: parseFloat(mesa.x_position),
        y_pos: parseFloat(mesa.y_position),
        height: parseFloat(mesa.height),
        width: parseFloat(mesa.width),
        people: mesa.people,
        used: mesa.used,
        user_name: mesa.user_name,
        user_id: mesa.user_id,
        tag: mesa.tag,
        state: mesa.state,
        time_used: mesa.time_used,
        time_charged: mesa.time_charged,
        time_last_order: mesa.time_last_order,
        charged: mesa.charged,
        is_merged: mesa.is_merged,
        is_virtual: mesa.is_virtual || false,
  parent_mesa_id: mesa.parent_mesa_id !== null ? mesa.parent_mesa_id : null,
  total_charges: typeof mesa.total_charges === 'number' ? mesa.total_charges : (mesa.total_charges != null ? Number(mesa.total_charges) : 0)
    ,
    // Real-time current people count coming from API (may be undefined)
    current_people: typeof mesa.current_people === 'number' ? mesa.current_people : (mesa.currentPeople ?? mesa.current_people_count ?? 0)
    };
}

export function convertObjetoFromAPI(objeto: any): Objeto {
    return {
        id: objeto.objeto_id,
        name: objeto.objeto_name,
        x_pos: parseFloat(objeto.x_position),
        y_pos: parseFloat(objeto.y_position),
        height: parseFloat(objeto.height),
        width: parseFloat(objeto.width),
        state: objeto.state
    };
}

// Helper function to find the closest available position
const findClosestAvailablePosition = (mesas:any, objetos:any) => {
  const takenPositions = new Set(mesas.concat(objetos).map((item:any) => `${item.x_pos},${item.y_pos}`));
  const targetX = 20;
  const targetY = 20;
  let radius = 0;

  while (true) {
    for (let dx = -radius; dx <= radius; dx++) {
      for (let dy = -radius; dy <= radius; dy++) {
        if (Math.abs(dx) !== radius && Math.abs(dy) !== radius) continue;
        const x = targetX + dx;
        const y = targetY + dy;
        if (!takenPositions.has(`${x},${y}`)) {
          return { x, y };
        }
      }
    }
    radius++;
  }
}

export const addMesa = (
  selectedSalon: Salon,
  setSelectedItem: (item: Mesa) => void,
  updateSalonState: (salon: Salon) => void,
  salones ?: Salon[],
) => {
  if (!selectedSalon) return null;

  const newMesaId = Math.max(0, ...selectedSalon.mesas.map(m => m.id), ...selectedSalon.objetos.map(o => o.id)) + 1;
  const user = localStorage.getItem('user');
  const localId = user ? JSON.parse(user).local_id : 0;
  const { x, y } = findClosestAvailablePosition(selectedSalon.mesas, selectedSalon.objetos);
  let maxNum = 0;
  if (salones && Array.isArray(salones)) {
    const allMesasNumbers = salones.flatMap(salon => salon.mesas.map(mesa => parseInt(mesa.num, 10) || 0));
    maxNum = allMesasNumbers.length > 0 ? Math.max(...allMesasNumbers) : 0;
  } else {
    const mesasNumbers = selectedSalon.mesas.map(mesa => parseInt(mesa.num, 10) || 0);
    maxNum = mesasNumbers.length > 0 ? Math.max(...mesasNumbers) : 0;
  }
  const num_max_mesa = (maxNum + 1).toString();

  let newMesa: Mesa = {
      id: newMesaId,
      num: num_max_mesa,
      x_pos: x, //here we should have the closest point to 20 that is available
      y_pos: y, //here we should have the closest point to 20 that is available
      height: 100,
      width: 100,
      user_name: null,
      user_id: null,
      people: 0,
    current_people: 0,
      used: false,
      state: true,
      tag : null,
      time_used: null,
      time_charged: null,
      time_last_order: null,
      is_merged: false,
      parent_mesa_id: null,
  charged: false,
  total_charges: 0
  };
  toast.info('Preparando tu nueva mesa!')
  createMesa({
      mesa_number: newMesa.num,
      x_position: newMesa.x_pos,
      y_position: newMesa.y_pos,
      width: newMesa.width,
      height: newMesa.height,
      salon_id: selectedSalon.salon_id,
      local_id: localId,
      tag: newMesa.tag,
      people: newMesa.people,
      state: newMesa.state,
      used: newMesa.used
  }).then(response => {
      newMesa.id = (response as any).data.mesa_id; // Assuming API returns mesa_id
      const updatedMesas = [...selectedSalon.mesas, newMesa];
      setSelectedItem(newMesa);
      updateSalonState({ ...selectedSalon, mesas: updatedMesas });
      toast.success('Mesa creada con éxito');
  }).catch(error => {
      const msg = error?.response?.data?.message;
      if (msg === "Una mesa con el mismo numero ya existe en el local.") {
        toast.error('Cambie el número de la mesa para crear una nueva');
      } else {
        console.error('Error al crear la mesa: ', msg);
        toast.error('Error al crear mesa');
      }
  });

  return newMesa;
};

export const DuplicarMesa = (
  mesa: Mesa,
  selectedSalon: Salon,
  setSelectedItem: (item: Mesa) => void,
  updateSalonState: (salon: Salon) => void,
  setSalones?: (salones: Salon[]) => void,
  salones?: Salon[]
) => {
  if (!selectedSalon || !mesa) return null;

  const newMesaId = Math.max(0, ...selectedSalon.mesas.map(m => m.id), ...selectedSalon.objetos.map(o => o.id)) + 1;
  const user = localStorage.getItem('user');
  const localId = user ? JSON.parse(user).local_id : 0;
  const { x, y } = findClosestAvailablePosition(selectedSalon.mesas, selectedSalon.objetos);

  // Encontrar el número de mesa más alto en todos los salones
  let maxNum = 0;
  if (salones && Array.isArray(salones)) {
    maxNum = Math.max(
      ...salones.flatMap(salon => salon.mesas.map(mesa => parseInt(mesa.num, 10) || 0))
    );
  } else {
    maxNum = Math.max(...selectedSalon.mesas.map(mesa => parseInt(mesa.num, 10) || 0));
  }
  const newNum = (maxNum + 1).toString();

  let newMesa: Mesa = {
    ...mesa,
    id: newMesaId,
    num: newNum,
    x_pos: x,
    y_pos: y,
    used: false,
    user_name: null,
    user_id: null,
    tag: null, // Tag vacío para que el usuario lo configure
    time_used: null,
    time_charged: null,
    time_last_order: null,
    charged: false,
    total_charges: 0,
    is_virtual: false // Reset virtual flag
  };

  toast.info('Duplicando mesa...');
  createMesa({
    mesa_number: newMesa.num,
    x_position: newMesa.x_pos,
    y_position: newMesa.y_pos,
    width: newMesa.width,
    height: newMesa.height,
    salon_id: selectedSalon.salon_id,
    local_id: localId,
    people: newMesa.people,
    state: newMesa.state,
    used: newMesa.used,
    tag: newMesa.tag
  }).then(response => {
    newMesa.id = (response as any).data.mesa_id;
    const updatedMesas = [...selectedSalon.mesas, newMesa];
    const updatedSalon = { ...selectedSalon, mesas: updatedMesas };
    setSelectedItem(newMesa);
    updateSalonState(updatedSalon);
    // Actualiza el array global de salones si se provee
    if (setSalones && salones) {
      setSalones(
        salones.map(salon =>
          salon.salon_id === updatedSalon.salon_id ? updatedSalon : salon
        )
      );
    }
    toast.success('Mesa duplicada con éxito');
  }).catch(error => {
    const msg = error?.response?.data?.message;
    if (msg === "Una mesa con el mismo numero ya existe en el local.") {
      toast.error('Una mesa con el mismo número ya existe en el local.');
    } else {
      console.error('Error al duplicar la mesa: ', msg);
      toast.error('Error al duplicar mesa');
    }
  });

  return newMesa;
};

export const addObjeto = (
  selectedSalon: Salon,
  setSelectedItem: (item: Objeto) => void,
  updateSalonState: (salon: Salon) => void
) => {
  if (!selectedSalon) return null;

  const newObjetoId = Math.max(0, ...selectedSalon.mesas.map(m => m.id), ...selectedSalon.objetos.map(o => o.id)) + 1;
  const user = localStorage.getItem('user');
  const localId = user ? JSON.parse(user).local_id : 0;
  const { x, y } = findClosestAvailablePosition(selectedSalon.mesas, selectedSalon.objetos);
  const newObjeto: Objeto = {
    id: newObjetoId,
    name: "Nuevo Objeto",
    x_pos: x, //here we should have the closest point to 20 that is available
    y_pos: y, // here we should have the closest point to 20 that is available
    height: 100,
    width: 100,
    state: true,
  };

  toast.info('Preparando tu nuevo objeto!')
  createObjeto({
    objeto_name: newObjeto.name,
    x_position: newObjeto.x_pos,
    y_position: newObjeto.y_pos,
    width: newObjeto.width,
    height: newObjeto.height,
    salon_id: selectedSalon.salon_id, // Assuming you also need salon_id
    state:true,
    local_id: localId,
  }).then(response => {
    newObjeto.id = (response as any).data.objeto_id; // Assuming API returns objeto_id
    const updatedObjetos = [...selectedSalon.objetos, newObjeto];
    setSelectedItem(newObjeto);
    updateSalonState({ ...selectedSalon, objetos: updatedObjetos });
    toast.success('Objeto creado con éxito');
  }).catch(error => {
    console.error('Error al crear el objeto: ', error.response.data.message);
    toast.error('Error al crear objeto');
  });

  return newObjeto;
};
